module.exports = {"pathContext":{"name":"ProductConfigInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"defaultNotes","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"dosageConfig","type":{"kind":"INPUT_OBJECT","name":"DosageConfigInput","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/input-object-product-config-input.json
// module id = 1517
// module chunks = 272286920478453